<template>
  <el-drawer
    :class="device.isIPhoneX ? 'fill-error-x' : ''"
    title="纠错"
    :visible.sync="drawerFillError"
    direction="btt"
    size="72%"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    class="fillError"
    @close="cancelFillError"
  >
    <!--                                :before-close="handleClose"-->
    <div class="drawerMain-box writeNote-box" id="fillError_top">
      <p class="block-label">问题类型：</p>
      <div class="q-type">
        <el-radio v-model="radioErrorType" label="1" border size="medium"
          >错别字</el-radio
        >
        <el-radio v-model="radioErrorType" label="2" border size="medium"
          >内容错误</el-radio
        >
        <el-radio v-model="radioErrorType" label="3" border size="medium"
          >其他</el-radio
        >
      </div>
      <p class="block-label">问题描述：</p>
      <textarea
        class="writeNote-textarea error-textarea"
        placeholder="请描述您遇到的故障问题"
        v-model="noteTextareaContent"
      ></textarea>
      <div class="upload-img-box">
        <!-- 勿删 截屏功能，暂时隐藏 -->
        <!-- <div class="el-upload-list__item">
          <el-image
            width="30%"
            :src="uploadImg.screenshotData"
            :preview-src-list="uploadImg.srcList"
            crossOrigin="anonymous"
          >
          </el-image>
        </div>-->
        <el-upload
          action=""
          ref="upload"
          list-type="picture-card"
          multiple=""
          :limit="uploadImg.uploadLimit"
          :file-list="uploadImg.fileList"
          :on-exceed="handleExceed"
          :on-change="handleChange"
          :auto-upload="false"
          accept=".png, .jpg, .jpeg, .gif, .bmp"
          :class="uploadImg.fileList.length >= 3 ? 'upload-limit' : ''"
        >
          <div slot="trigger" @click.stop="uploadHandle">
            <i slot="default" class="el-icon-plus"></i>
          </div>
          <!-- <i slot="default" class="el-icon-plus"></i> -->
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt=""
            />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handlePictureCardPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <span
                v-if="!disabled"
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </div>
      <p class="tips">最多可上传3张图片</p>

      <div class="btn-box">
        <button type="submit" class="btn" @click="submitNote('error')">
          提交
        </button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
  export default {
    name: "fillErrorDrawer",
    props: {
      //drawer 是否展示
      drawerFillError: {
        type: Boolean,
        default: false,
      },
      selectedText: {
        type: String,
        default: '',
      },
      // noteTextareaContent: {
      //   type: String,
      //   default: '',
      // },
      noteDrawerType: {
        type: String,
        default: 'add',
      },
    },
    data() {
      return {
        radioErrorType: '1',
        uploadImg: {
          screenshotData: "", // 存储截图数据的变量
          fileList: [], // 已上传文件列表
          uploadLimit: 3, // 上传限制数量
          srcList: [], // 放大后的图片列表
        },
        noteTextareaContent: "",


        textareaContent: ''
      }
    },
    watch: {
      noteTextareaContent() {
        this.textareaContent = this.noteTextareaContent
      }
    },
    methods: {
      changeNoteTextarea() {
        this.$emit('changeNoteTextarea', this.textareaContent)
      },
      // 超出数量限制后的提示
      handleExceed() {
        // this.$message.warning(`当前限制选择 ${this.uploadImg.uploadLimit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        this.$message({
          message: "超出数量限制!",
          type: "error",
          duration: 2000,
          customClass: "myMessageTip", // 自定义类名
        });
      },
      uploadHandle() {
        if(this.device.isMobile && this.device.isApp && !this.device.isIos) {
            window.Android.clearChooseFile(function(res) {
              console.log(res)
              // this.uploadClick()
            });
            setTimeout(() => {
              this.uploadClick()
            }, 500)
        }else{
          this.uploadClick()
        }
      },
      // 手动触发点击事件
      uploadClick() {
        const uploadComponent = this.$refs.upload;
        const inputElement = uploadComponent.$el.querySelector('input[type="file"]');
        // 手动触发点击事件
        if (inputElement) {
          inputElement.click();
        }
      },
      handleChange(file, fileList) {
        this.uploadImg.fileList = JSON.parse(JSON.stringify(fileList));
      },
      // 删除图片
      handleRemove(file) {
        var pic_li = event.target.closest("li");
        this.$confirm("确定要删除当前图片？")
          .then(() => {
            const index = this.uploadImg.fileList.findIndex((item) => {
              return item.uid === file.uid;
            });
            this.uploadImg.fileList.splice(index, 1);
            pic_li.remove();
          })
          .catch(() => {});
      },
      //预览图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 点击记笔记中的提交，追加笔记列表
      submitNote(type) {
        if (this.noteTextareaContent == "") {
          this.$message({
            message: "请填写内容后再提交",
            type: "error",
            duration: 2000,
            customClass: "myMessageTip", // 自定义类名
          });
        } else {
          this.$message.success('提交成功！');
          // this.$emit('submitNote', type)
          this.cancelFillError()
          this.noteTextareaContent = "";
          this.uploadImg.fileList = [];
          this.uploadImg.screenshotData = "";
          this.radioErrorType = "1";
        }
      },
      // 滚动弹窗到最顶部
      scrollTop(toId) {
        var box = document.getElementById(toId);
        box.scrollTop = 0; // 设置scrollTop为0，滚动到最顶部
      },
      // 取消写笔记
      cancelFillError(type) {
        this.scrollTop("fillError_top")
        this.$emit('cancelFillError', type)
      },
    }
  }
</script>

<style scoped lang="scss">
/deep/.el-drawer{
  border-radius: 20rem 20rem 0 0;

  .el-drawer__header{
    padding: 0 42rem 0 32rem;
    margin: 0;
    border-bottom: 2rem solid #E3E3E3;

    span{
      font-size: 36rem;
      color: #333;
      font-weight: bold;
      line-height: 112rem;
    }

    .el-drawer__close-btn{
      font-size: 36rem;
    }
  }
}
/deep/.el-radio{
  border-color: #C1C1C1;
  color: #666;
  margin-right: 20rem;
  .el-radio__inner{
    border-color: #C1C1C1;
  }
}
/deep/.el-radio--medium.is-bordered {
  padding-left: 15rem;
  padding-right: 25rem;
}
/deep/.el-radio.is-bordered.is-checked{
  border-color: #0FC29A;
  .el-radio__label{
    color: #0FC29A;
  }
  .el-radio__inner{
    border-color: #0FC29A;
    background: #0FC29A;
  }
}
/deep/.upload-limit{
  .el-upload--picture-card{
    display: none;
  }
}
/* 弹窗样式 start */
.drawerMain-box {
  text-align: left;
  height: 100%;
  overflow: auto;
  padding: 0 24rem;
  padding-bottom: 148rem;
  .block-label {
    font-size: 28rem;
    line-height: 42rem;
    margin-bottom: 20rem;
    margin-top: 25rem;
  }
  .q-type{
    margin-bottom: 56rem;
  }
  .tips {
    font-size: 24rem;
    margin-bottom: 8rem;
    color: #999;
  }
  .quote-txt {
    margin-bottom: 20rem;
    padding: 16rem;
    height: auto;
    max-height: 78rem;
    font-size: 16rem;
    line-height: 28rem;
    background: #f2f2e7;
    border-radius: 6rem;
  }
  /deep/.quote-txt.quote-txt-2 {
    padding: 10rem 16rem;
    background: #f1f1f1;
    border: 1rem dashed #4f678e;
    border-radius: 2rem;
    max-height: 54rem;
    font-size: 14rem;
    margin-bottom: 10rem;
  }
  /deep/.upload-img-box {
    display: flex;
    align-items: flex-start;
    > .el-upload-list__item {
      margin: 0 8rem 8rem 0;
      width: 80rem;
      height: 80rem;
      border-radius: 6rem;
      overflow: hidden;
      border: 1rem solid #c0ccda;
      display: flex;
      img {
        width: 100%;
      }
    }
  }
  .writeNote-textarea {
    padding: 30rem;
    margin-bottom: 20rem;
    width: 100%;
    min-height: 100rem;
    height: 300rem;
    font-size: 28rem;
    font-family: unset;
    color: #2f4058;
    border-radius: 10rem;
    line-height: 42rem;
    border: 1rem solid #c1c1c1;
    -moz-user-select: auto !important; /*火狐*/
    -webkit-user-select: auto !important; /*webkit浏览器*/
    -ms-user-select: auto !important; /*IE10*/
    -khtml-user-select: auto !important; /*早期浏览器*/
    user-select: auto !important;
    list-style: auto !important;
    outline: none;
  }
  .writeNote-textarea:focus {
    border: 1px solid #0FC29A;
  }
  .btn-box {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 30rem 0;
    background: #fff;
    /*text-align: center;*/
    .btn {
      display: block;
      width: 600rem;
      margin: 0 auto;
      border: none;
      height: 88rem;
      font-size: 32rem;
      color: #fff;
      text-align: center;
      font-weight: bold;
      line-height: 88rem;
      background: #0FC29A;
      border-radius: 44rem;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
      color: #fff;
    }
  }
}
/* 记笔记弹窗样式 end */
.fill-error-x{
  .drawerMain-box{
    padding-bottom: 180rem;
  }
  .btn-box{
    padding-bottom: 62rem;
  }
}
</style>